import React from "react";
import Firebase from "../../firebasehelper";
class ResetPasswordSuperAdminModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
    };
  }

  componentDidMount() {
    const { initialValues } = this.props;

    if (initialValues) {
      this.setState({
        password: "",
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { initialValues } = this.props;
    if (initialValues !== prevProps.initialValues) {
      this.setState({
        password: "",
      });
    }
  }
  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onSave = () => {
    const { password } = this.state;
    const { onSave } = this.props;
    onSave(password);
  };
  render() {
    const { password } = this.state;
    const { hex, white } = this.props;
    return (
      <div
        className="modal fade"
        id="reset_password_super_admin"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Reset password</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div className="form-group">
                <input
                  type="password"
                  className="form-control form-control-lg form-control-alt"
                  id="signup-password"
                  name="password"
                  placeholder="Password"
                  onChange={this.onChangeHandler}
                  value={password}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-brand-hex btn-white"
                style={{
                  "--hover-text-color": white ? "white" : "black",
                  "--hover-color": hex,
                  backgroundColor: "white",
                  color: "black",
                }}
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-green"
                data-dismiss="modal"
                onClick={this.onSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ResetPasswordSuperAdminModal;



// WEBPACK FOOTER //
// ./src/components/ResetPasswordSuperAdminModal/index.js